import { SelectSearch } from "Explore/Components";
import { ImageCheckType, ImageType } from "Explore/Config/ImageType";
import {
  getInstitutionDetailSummaryByID,
  getInstitutionPublicationsByID,
  getInstitutionScholarsByID,
  getInstitutionTopAwardedGrants,
  getInstitutionTopRankingKeywords,
} from "Explore/Services/Institution";
import { checkImageUrl } from "Explore/Utils/CheckImageUrl";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AcademicInformation,
  BackgroundImage,
  BasicInformation,
  InternationalCollaborators,
} from "./Components";
import styles from "./InstitutionDetail.module.scss";
import { setLandscapeBackground } from "Redux/Slices/Common";
import { useDispatch, useSelector } from "react-redux";
import useExploreInfo from "Hooks/useExploreInfo";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet-async";

const InstitutionDetail = () => {
  const navigate = useNavigate();
  const filterStates = useLocation().state;

  const { entity_id: institution_id } = useExploreInfo();
  const { landscapeBackground } = useSelector((state) => state.commonState);
  const dispatch = useDispatch();

  const [showLoginSection, setShowLoginSection] = useState(false);
  // Data
  const [summary, setSummary] = useState({ data: [], isLoading: true });
  const [scholars, setScholars] = useState({ data: [], isLoading: true });
  // const [publications, setPublications] = useState({
  //   data: [],
  //   isLoading: true,
  // });
  const [awards, setAwards] = useState({
    data: [],
    isLoading: true,
  });
  //filters
  const [facultySearchFilter, setFacultySearchFilter] = useState(
    filterStates?.facultySearchFilter
      ? filterStates.facultySearchFilter
      : {
        institution_ids: [],
        query: null,
        orderBy: "h_index",
      }
  );
  const [grantsFilter, setGrantsFilter] = useState(
    filterStates?.grantsFilter ?? {
      orderBy: "amount_awarded",
      order: "desc",
    }
  );

  const [pagination, setPagination] = useState(
    filterStates?.pagination
      ? filterStates.pagination
      : {
        page: 1,
        rowsPerPage: 10,
        totalRows: 0,
        hasNextPage: false,
      }
  );
  const [publicationVerify, setPublicationVerify] = useState(
    filterStates?.publicationVerify ? filterStates.publicationVerify : true
  );
  const [tab, setTab] = useState(
    filterStates?.tab ? filterStates.tab : "scholars"
  );

  //concept word cloud
  const [granularityLevel, setGranularityLevel] = useState(
    filterStates?.granularityLevel ? filterStates.granularityLevel : 1
  );
  const [selectedKeywords, setSelectedKeywords] = useState(
    filterStates?.selectedKeywords ? filterStates.selectedKeywords : []
  );
  const [selectedKeywordsQueue, setSelectedKeywordsQueue] = useState(
    filterStates?.selectedKeywordsQueue
      ? filterStates.selectedKeywordsQueue
      : []
  );
  //slider
  const [sliderValue, setSliderValue] = useState(
    filterStates?.sliderValue ? filterStates.sliderValue : [1970, 2024]
  );

  const [notableConcepts, setNotableConcepts] = useState([]);
  const canonicalInstitutionSlug = summary?.data?.explore_slug || institution_id;

  useEffect(() => {
    navigate(`/explore/institution/${canonicalInstitutionSlug}`, {
      state: {
        facultySearchFilter: facultySearchFilter,
        grantsFilter: grantsFilter,
        publicationVerify: publicationVerify,
        tab: tab,
        granularityLevel: granularityLevel,
        selectedKeywords: selectedKeywords,
        selectedKeywordsQueue: selectedKeywordsQueue,
        sliderValue: sliderValue,
        pagination: pagination,
      },
      replace: true,
    });
  }, [
    canonicalInstitutionSlug,
    facultySearchFilter,
    grantsFilter,
    publicationVerify,
    tab,
    granularityLevel,
    selectedKeywords,
    selectedKeywordsQueue,
    sliderValue,
    pagination,
  ]);

  // init data - slider
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getInstitutionDetailSummaryByID(institution_id, (res) => {
      setSummary({ data: res, isLoading: false });
      if (res?.explore_slug && res.explore_slug !== institution_id) {
        navigate(`/explore/institution/${res.explore_slug}`, {
          state: filterStates,
          replace: true,
        });
      }
      checkImageUrl(
        `https://media.academic.online/institutions_images/${res?.id}/${ImageType.LANDSCAPE}.png`,
        (img) => dispatch(setLandscapeBackground(img)),
        ImageCheckType.INSTITUTION_LANDSCAPE
      );
      setFacultySearchFilter({
        ...facultySearchFilter,
        institution_ids: [institution_id],
      });
      getInstitutionTopRankingKeywords({ institution_id }).then((rankingRes) => {
        setNotableConcepts(rankingRes);
      });
    });

    return () => {
      dispatch(setLandscapeBackground(null));
    };
  }, []);

  // useEffect(() => {
  //   if (tab == "scholars") {
  //     setScholars({ data: [], isLoading: true });
  //     const keywordsForFiltering =
  //       selectedKeywordsQueue && !selectedKeywords.length > 0
  //         ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
  //         : selectedKeywords;

  //     getInstitutionScholarsByID(
  //       institution_id,
  //       facultySearchFilter.query,
  //       pagination.page - 1,
  //       pagination.rowsPerPage,
  //       sliderValue[0],
  //       sliderValue[1],
  //       keywordsForFiltering,
  //       null,
  //       facultySearchFilter.orderBy,
  //       (res) => {
  //         setScholars({ data: res.authors, isLoading: false });
  //         if (res.total) {
  //           setPagination({
  //             ...pagination,
  //             totalRows: res.total,
  //           });
  //         }
  //       },
  //       (err) => {
  //         if (err?.response?.status === 401) {
  //           setShowLoginSection(true);
  //         }
  //         setScholars({ data: [], isLoading: false });
  //       }
  //     );
  //   }
  // }, [
  //   selectedKeywords,
  //   sliderValue,
  //   pagination.page,
  //   pagination.rowsPerPage,
  //   tab,
  //   facultySearchFilter.query,
  //   facultySearchFilter.orderBy,
  // ]);

  // useEffect(() => {
  //   if (tab == "publications") {
  //     setPublications({ data: [], isLoading: true });

  //     const keywordsForFiltering =
  //       selectedKeywordsQueue && !selectedKeywords.length > 0
  //         ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
  //         : selectedKeywords;

  //     getInstitutionPublicationsByID(
  //       institution_id,
  //       null,
  //       keywordsForFiltering,
  //       publicationVerify,
  //       sliderValue[0],
  //       sliderValue[1],
  //       pagination.page - 1,
  //       pagination.rowsPerPage,
  //       (res) => {
  //         setPublications({ data: res.results, isLoading: false });
  //         setPagination({ ...pagination, totalRows: res.total });
  //       },
  //       (err) => {
  //         if (err?.response?.status === 401) {
  //           setShowLoginSection(true);
  //         }
  //         setPublications({ data: [], isLoading: false });
  //       }
  //     );
  //   }
  // }, [
  //   selectedKeywords,
  //   sliderValue,
  //   pagination.page,
  //   pagination.rowsPerPage,
  //   tab,
  //   publicationVerify,
  // ]);

  // useEffect(() => {
  //   if (tab == "grants") {
  //     setAwards({ data: [], isLoading: true });

  //     const keywordsForFiltering =
  //       selectedKeywordsQueue && !selectedKeywords.length > 0
  //         ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
  //         : selectedKeywords;
  //     getInstitutionTopAwardedGrants(
  //       institution_id,
  //       null,
  //       keywordsForFiltering,
  //       pagination.page - 1,
  //       pagination.rowsPerPage,
  //       sliderValue[0],
  //       sliderValue[1],
  //       grantsFilter.orderBy,
  //       grantsFilter.order,
  //       (res) => {
  //         setAwards({ data: res.awards, isLoading: false });
  //         if (res.total >= 0) {
  //           setPagination({ ...pagination, totalRows: res.total });
  //         }
  //       },
  //       (err) => {
  //         if (err?.response?.status === 401) {
  //           setShowLoginSection(true);
  //         }
  //         setAwards({ data: [], isLoading: false });
  //       }
  //     );
  //   }
  // }, [
  //   institution_id,
  //   selectedKeywords,
  //   selectedKeywordsQueue,
  //   pagination.page,
  //   pagination.rowsPerPage,
  //   tab,
  //   sliderValue,
  //   grantsFilter,
  // ]);

  const currentUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
  
  const generateTitle = () => {
    if (!summary.data?.name && !summary.data?.inst_name) return "Institution Profile | Academic Online";
    const name = summary.data?.name || summary.data?.inst_name;
    const location = summary.data?.city && summary.data?.state ? `${summary.data.city}, ${summary.data.state}` : summary.data?.country;
    const suffix = " | Academic Online";
    const maxLength = 60;

    let titleFull = `${name} — Faculty, Research & Programs${location ? ` | ${location}` : ""}`;
    if ((titleFull + suffix).length <= maxLength) return titleFull + suffix;

    let titleShort = `${name} — Faculty & Research${location ? ` | ${location}` : ""}`;
    if ((titleShort + suffix).length <= maxLength) return titleShort + suffix;

    let titleLocation = location ? `${name} | ${location}` : name;
    if ((titleLocation + suffix).length <= maxLength) return titleLocation + suffix;

    if ((name + suffix).length <= maxLength) return name + suffix;

    return `${name.substring(0, 40)}...${suffix}`;
  };
  
  const generateDescription = () => {
    const defaultDesc = "View detailed institution profile including academic departments, faculty members, and research output.";
    const instName = summary.data?.name || summary.data?.inst_name;
    if (!instName) return defaultDesc;

    const location = summary.data?.city && summary.data?.state ? `${summary.data.city}, ${summary.data.state}` : summary.data?.country;
    const maxLength = 160;

    let descFull = location ? `Explore ${instName} in ${location}. Browse faculty profiles, academic departments, research output, and top publications.` : `Explore ${instName}. Browse faculty profiles, academic departments, research output, and top publications.`;
    if (descFull.length <= maxLength) return descFull;

    let descNoLocation = `Explore ${instName}. Browse faculty profiles, academic departments, research output, and top publications.`;
    if (descNoLocation.length <= maxLength) return descNoLocation;

    return `${descNoLocation.substring(0, 157)}...`;
  };

  return (
    <div className={styles["institution-detail"]}>
      <Helmet>
        <title>{generateTitle()}</title>
        <meta name="description" content={generateDescription()} />
        <link rel="canonical" href={currentUrl} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content={generateTitle()} />
        <meta property="og:description" content={generateDescription()} />
      </Helmet>
      <div className={`${styles["section"]} ${styles["section--hero"]}`}>
        <BasicInformation
          institution_id={institution_id}
          summary={summary}
          landscape={landscapeBackground}
        />
      </div>
      <div className={`${styles["section"]} ${styles["section--alt"]}`}>
        <Container>
          <InternationalCollaborators institution_id={institution_id} />
        </Container>
      </div>
      <main>
        <AcademicInformation
          institution_id={institution_id}
          landscape={landscapeBackground}
          selectedKeywords={selectedKeywords}
          setSelectedKeywords={setSelectedKeywords}
          selectedKeywordsQueue={selectedKeywordsQueue}
          setSelectedKeywordsQueue={setSelectedKeywordsQueue}
          granularityLevel={granularityLevel}
          setGranularityLevel={setGranularityLevel}
          sliderValue={sliderValue}
          setSliderValue={setSliderValue}
          scholars={scholars}
          setScholars={setScholars}
          // publications={publications}
          publicationVerify={publicationVerify}
          setPublicationVerify={setPublicationVerify}
          awards={awards}
          tab={tab}
          setTab={setTab}
          facultySearchFilter={facultySearchFilter}
          setFacultySearchFilter={setFacultySearchFilter}
          grantsFilter={grantsFilter}
          setGrantsFilter={setGrantsFilter}
          selectedDepartment={SelectSearch}
          pagination={pagination}
          setPagination={setPagination}
          notableConcepts={notableConcepts}
          showLoginSection={showLoginSection}
        />
      </main>
    </div>
  );
};

export default InstitutionDetail;
